import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import favLogo from '../images/star-regular-brown.svg'
import favLogoSolid from '../images/star-solid-brown.svg'
import { useAuth } from '../context/AuthContextProvider';


import { ADD_APP_ACCESS_LEVELS } from 'src/constants/AppConstants'
import ApprovalsHome from '../Approvals/approvalsHome';
import { createPreference, updatePreference, deletePreference, listPreference  } from "src/utilities/AppSyncPlusAPIs";
import { v4 as uuidv4 } from 'uuid';


import {
  AppLayout,
  BreadcrumbGroup,
  Container,
  Box,
  Cards,
  Button,
  Header,
  Table,
  Badge,
  Autosuggest,
  ExpandableSection,
  SpaceBetween,
  Multiselect,
  ColumnLayout,
  Tabs,
  Pagination,
  Spinner,
  Flashbar,
  ButtonDropdown,
  CopyToClipboard,
  ContentLayout,
  Icon,
  PieChart,
  Select,
  HelpPanel,
  Grid,
  Steps,
  Popover,
  SegmentedControl,
  TextContent,
  Toggle,
  ToggleButton
} from "@amzn/awsui-components-react";

import "./homepage.scss";
import StarRating from "./StarRating";
import { getUserRatings, submitRating, deleteRating } from "src/utilities/RatingAPIs";
import { useSelector, useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import { addFavorite, listFavorites, delFavorite, getFavorite } from '../utilities/Favorites'
import Favorite from 'src/generic-components/Favorite';
import { TEMPLATE_APP, TEMPLATE_APP_PERMISSION, TEMPLATE_APP_TEAM, TEMPLATE_APP_OUTPUT, TEMPLATE_APP_ACCOUNTING, TEMPLATE_APP_USE_CASE, TEMPLATE_APP_SOURCE_DATA_TABLES, TEMPLATE_APP_CHART_OF_ACCOUNTS } from 'src/Ateam-BI/Templates/Constants';
import { API, graphqlOperation } from "aws-amplify";
import { getEditableFields } from "src/Ateam-BI/Templates/Utils/FormMetadata";
import { setCurrentAppId } from "src/store/userAuthSlice";
import { setOrganization } from "src/store/userAuthSlice";
import { getAccessLevel } from "src/checkPageAccess"
import { TEMPLATES, APP_TYPES, APP_STATUSES } from 'src/Ateam-BI/Templates/Constants';
import Featured from "src/generic-components/Featured";

import { fetchApps } from "../Ateam-BI/Templates/Utils/AppActivityUtils"
import { useSuggestedLogins } from "src/hooks/useSuggestedLogins";
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"

function Apps(props) {  

    const history = useHistory();
      const isCurrentAppAuthorised = useSelector(
        (globalState) => globalState.auth.isCurrentAppAuthorized
      );
      const userAuthenticationDetails = useAuth();
      const firstName = userAuthenticationDetails.GivenName;
      const userId = useSelector((globalState) => globalState.auth.userId);
      const currentStage = useSelector((globalState) => globalState.auth.currentStage)
      const [qscAddAppAccessDisabled, setQscAddAppAccessDisabled] = useState(true)
      const [racAddAppAccessDisabled, setRacAddAppAccessDisabled] = useState(true)
      const [abcAddAppAccessDisabled, setAbcAddAppAccessDisabled] = useState(true)
      const ln = useLocation()
    
    
      const [products, setProducts] = useState([]);
      const [filteredProducts, setFilteredProducts] = useState([]);
    
      const [isProducsLoading, setIsProducsLoading] = useState(true);
      const [appsLoadError, setAppsLoadError] = useState(null);
      const [toolsHide, setToolsHide] = useState(true);
    
      const [filteringOptions, setFilteringOptions] = useState([]);
      const [NavOpen, setNavOpen] = useState(true);
      const [toolsOpen, setToolsOpen] = useState(false);
    
      const [value, setValue] = useState("");
    
      const [selectedOptions, setSelectedOptions] = useState();
    
      const [organizations, setOrganizations] = useState([]);
      const [useCaseTypes, setUseCaseTypes] = useState([]);
      const [statuses, setStatuses] = useState([])
      const [allAutomationTools, setAllAutomationTools] = useState([])
      const [allAccountingVps, setAllAccountingVps] = useState([]);
      const [processOutputs, setProcessOutputs] = useState([]);
      const [appTypes, setAppTypes] = useState([]);
      const [processOwners, setProcessOwners] = useState([]);
      const [financialRelevanceValues, setFinancialRelevanceValues] = useState([]);
      const [regions, setRegions] = useState([]);
      const [accountingTeams, setAccountingTeams] = useState([]);
      const [developerTeams, setDeveloperTeams] = useState([]);
      const [cadences, setCadences] = useState([]);
      const [launchDates, setLaunchDates] = useState([]);
      const [inputDataSources, setInputDataSources] = useState([]);
      const [ledgerImpacts,setLedgerImpacts] = useState([])
      const [currentAppsLibraryPreferences, setCurrentAppsLibraryPreferences] = useState([])
      const [preferenceButtonLoading, setPreferenceButtonLoading] = useState(false)
    
      const [allSuggestions, setAllSuggestions] = useState([])
      const [searchSuggestions, setSearchSuggestions] = useState([])
      const [favoritesMap, setFavoritesMap] = useState({});
      const [favDisabled, setFavDisabled] = useState(false);
      const [ratingsMap, setRatingsMap] = useState({});
      const [activeTabId, setActiveTabId] = useState(false);
      const [appsActiveTabId, setAppsActiveTabId] = useState("apps");
      const [changeToggle, setChangeToggle] = useState(false);
      const [currentPageIndex, setCurrentPageIndex] = useState(1);
      const [pagesCount, setPagesCount] = useState()
      const [pageItems, setPageItems] = useState()
      const [fieldMetadata, setFieldMetadata] = useState({});
      const [loader, setLoader] = useState(false);
      const [loaderRequestsQueue, setLoaderRequestsQueue] = useState(new Set());
      const [view, setView] = useState('Grid')
      const qryRef = useRef(null);
      const [isProcessing, setIsProcessing] = useState(false)
      const currentHour = (new Date()).getHours()
      const [greeting, setGreeting] = useState(() => {
        if (currentHour < 12) {
          return "Good Morning"
        } else if (currentHour < 18) {
          return "Good Afternoon"
        } else {
          return "Good Evening"
        }
      })
      
      const { suggestedLogins, aliasesLoading, getSuggestedLoginsCaller } = useSuggestedLogins();
      const [supervisorChainCache, setSupervisorChainCache] = useState({})

      
    
      const { org } = useParams()
      const [ownedBy, setOwnedBy] = useState({label:`Default`, value:``})
    
      const dispatch = useDispatch();
      const search = useLocation().search
      const searchParams = new URLSearchParams(search)
      const [orgTogglechecked,setOrgToggleChecked] = useState( org ? true : false)
      const [addFiltersBools, setAddFiltersBools] = useState({
        'tools': true,
        'statuses': true,
        'orgs': true,
        'types': true,
        'vps': false,
        'outputs': false,
        'appTypes': false,
        'processOwners': false,
        'relevance': false,
        'regions': false,
        'accountingTeams': false,
        'developerTeams': false,
        'cadence': false,
        'launchDate': false,
        'inputSourceTypes': false,
        'ledgerImpacts': false
      })


    const LABEL_COLOR_CLASSES = ["card-label-blue", "card-label-grey", "card-label-red"]

    useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : userId,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${ln.pathname}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
        ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.APPS_LIBRARY);
    
      useEffect(() => {
        const handleFilters = async () => {

          await queryApps()
        }
        handleFilters()
        for (const key of searchParams.keys()) {
          
          if (addFiltersBools.hasOwnProperty(key)) {
            setAddFiltersBools((prevState) => {
              return { ...prevState, [key]: true }
            })
          }
        }
    
    
      }, [searchParams.toString(), ln.pathname, ownedBy, org])
    
      useEffect(() => {
        loadProducts();
        setActiveTabId(searchParams.get("section") ? searchParams.get("section") : 'default')
    
        return () => {
          // this now gets called when the component unmounts
          dispatch(setOrganization())
        };
      }, []);
    
      useEffect(() => {
        dispatch(setCurrentAppId(''));

        if (!searchParams.getAll('status')?.length) {
          searchParams.append('status', 'Active')
          history.replace({
            ...history.location.search, 
            search: `${searchParams.toString()}`,
          })
        }
      }, [])
    
      useEffect(() => {
        checkAddAppAccesses()
      }, [userId, currentStage])
    
      useEffect(() => {
        dispatch(setOrganization(org))
        if(org) {
          setOrgToggleChecked(true)
        } else {
          setOrgToggleChecked(false)
        }
      }, [org])
    
      useEffect(()=>{
        if(typeof(orgTogglechecked) === 'boolean' && orgTogglechecked === false && org){
    
            if(searchParams.toString()) {
              history.push(`/AppsLibrary?${searchParams.toString()}`)
            } else {
              history.push(`/AppsLibrary`)
            }
        } else {
          setOwnedBy()
        }
      },[orgTogglechecked])
    
    
      useEffect(() => {
        setPageItems(
          filteredProducts
            .slice(21 * (currentPageIndex - 1), 21 * (currentPageIndex))
        )
    
    
      }, [currentPageIndex, filteredProducts])
    
    
      useEffect(() => {
        const orgs = fieldMetadata[TEMPLATE_APP.ORGANIZATION]?.values;
        setOrganizations(orgs);
    
    
        const types = fieldMetadata[TEMPLATE_APP.USE_CASE]?.values;
        setUseCaseTypes(types);
    
        const processOutputs = fieldMetadata[TEMPLATE_APP.OUTPUT]?.values;
        setProcessOutputs(processOutputs);
    
        const allStatuses = fieldMetadata[TEMPLATE_APP.STATUS]?.values;
        setStatuses(allStatuses);
    
        const allAppAutomationTools = fieldMetadata[TEMPLATE_APP.AUTOMATION_TOOLS]?.values;
        setAllAutomationTools(allAppAutomationTools);
    
        const financialRelevances = fieldMetadata[TEMPLATE_APP.FINANCIAL_RELEVANCE]?.values;
        setFinancialRelevanceValues(financialRelevances)
    
        const regions = fieldMetadata[TEMPLATE_APP.REGION]?.values
        setRegions(regions)
    
        const accountingTeams = fieldMetadata[TEMPLATE_APP.ACCOUNTING_TEAM]?.values
        setAccountingTeams(accountingTeams)
    
        const developerTeams = fieldMetadata[TEMPLATE_APP.DEVELOPER_TEAM]?.values
        setDeveloperTeams(developerTeams)
    
        const cadence = fieldMetadata[TEMPLATE_APP.CADENCE]?.values
        setCadences(cadence)
        const launchDate = fieldMetadata[TEMPLATE_APP.LAUNCH_QQ_YY]?.values
        setLaunchDates(launchDate)
    
        const inputSourceType = fieldMetadata[TEMPLATE_APP.INPUT_SOURCE_TYPE]?.values
        setInputDataSources(inputSourceType)
        const ledgerImpacts = fieldMetadata[TEMPLATE_APP.LEDGER_INFO]?.values
        setLedgerImpacts(ledgerImpacts)
      }, [fieldMetadata])
    
      useEffect(() => {
    
        const orgs = fieldMetadata[TEMPLATE_APP.ORGANIZATION]?.values;
        setOrganizations(orgs);
    
    
        const types = fieldMetadata[TEMPLATE_APP.USE_CASE]?.values;
        setUseCaseTypes(types);
    
        const processOutputs = fieldMetadata[TEMPLATE_APP.OUTPUT]?.values;
        setProcessOutputs(processOutputs);
    
        const suggestions = products.map((product) => (
          {
            value: product.app_name,
            description: product.app_description
          }
        ))
        setAllSuggestions(suggestions)
        setSearchSuggestions(suggestions)
    
        setPagesCount(Math.ceil(products.length / 21))
      }, [products]);

      useEffect(() => {

        if(props.closePortalowner) {
          listPreference(
                      props.closePortalowner.value,                        
                      'CLOSE_PORTAL',                  
                      'APPS_LIBRARY_FILTER_CONFIG',      
                      function onSuccessResponse(response) {
                          const preferences = response?.data?.listPreference?.items || [];
                          
                          const validPreferences = preferences.filter(pref => {
                              if (pref.information) {
                                  const information = typeof pref.information === 'string'
                                      ? JSON.parse(pref.information)
                                      : pref.information;
                                  return information;
                              }
                              return false;
                          });

                          setCurrentAppsLibraryPreferences(validPreferences)
                          if(validPreferences?.length > 0) {
                            const info = JSON.parse(validPreferences[0]?.information)
                            if(info?.viewAs) {
                              setOwnedBy({label: info?.viewAs, value: info?.viewAs})
                            }
                            history.push(info?.path)

                          }
          
                      },
                      function onFailureResponse(error) {
                          
                      }
                  );
        }

      },[props.closePortalowner])
    
    
      const checkAddAppAccesses = async () => {
        if (userId && currentStage) {
          let abcAccess = await getAccessLevel(userId, TEMPLATES.MAPLE, currentStage)
          let qscAccess = await getAccessLevel(userId, TEMPLATES.QSC, currentStage)
          let racAccess = await getAccessLevel(userId, TEMPLATES.RAC, currentStage)
          // let racAccess = await getAccessLevel(userId, TEMPLATES.RAC, currentStage)
          setAbcAddAppAccessDisabled(!ADD_APP_ACCESS_LEVELS.includes(abcAccess?.appAccessLevel))
          setQscAddAppAccessDisabled(!ADD_APP_ACCESS_LEVELS.includes(qscAccess?.appAccessLevel))
          setRacAddAppAccessDisabled(!ADD_APP_ACCESS_LEVELS.includes(racAccess?.appAccessLevel))
          // setRacAddAppAccessDisabled(!ADD_APP_ACCESS_LEVELS.includes(racAccess?.appAccessLevel))
        }
    
      }
    
    
      const generateFilterDropdown = (allApps, dynamoDBKey) => {
        const valueSet = new Set();
        allApps
          .filter(p => p[dynamoDBKey] && p[dynamoDBKey] !== '' && p[dynamoDBKey] !== 'To be updated')
          .forEach(p => p[dynamoDBKey].forEach(val => { if (val !== 'nan') valueSet.add(val.trim()) }));
        const dropDown = [...valueSet].map(val => ({ label: val, value: val }));
        if (dynamoDBKey === TEMPLATE_APP.VP) setAllAccountingVps(dropDown);
        else if (dynamoDBKey === TEMPLATE_APP.PROCESS_OWNER) setProcessOwners(dropDown);
      }
    
      const generateAppTypesFilterDropdown = (allApps) => {
        const valueSet = new Set();
        allApps
          .filter(p => p[TEMPLATE_APP.TEMPLATE_ID] && p[TEMPLATE_APP.TEMPLATE_ID] !== '' && p[TEMPLATE_APP.TEMPLATE_ID] !== 'To be updated' && p[TEMPLATE_APP.TEMPLATE_ID] !== 'nan')
          .forEach(p => valueSet.add(p[TEMPLATE_APP.TEMPLATE_ID].trim()));
        setAppTypes([...valueSet].map(val => ({ label: APP_TYPES[val], value: val })));
      }
    
      const clearFavoriteMap = () => {
        let current_keys = Object.keys(favoritesMap)
        current_keys.forEach((key) => {
          delete favoritesMap[key]
        });
      }
    
      const makeFavoriteMap = (items) => {
        items.forEach((item, index) => {
          favoritesMap[item.preference_identifier] = true
        });
      }
    
      const getAllFavorites = async () => {
        listFavorites(userId, function onSuccess(result) {
          clearFavoriteMap()
          makeFavoriteMap(result.data.listUserPreferences.items)
          setFavDisabled(false)
        },
          function onFailure(result) {
    
          })
      }
    
      const isFavorite = async (appId) => {
        getFavorite(appId, userId, function onSuccess(result) {
          favoritesMap[appId] = true
        },
          function onFailure(result) {
            favoritesMap[appId] = false
          })
      }
    
      const getItemsForFilterFromDropdown = (items) => {
        let res = []
        items.forEach((item) => {
          res.push(item.value)
        })
        return res
      }

      const onSaveAppFiltersClick = async () => {
        if(props?.closePortalowner) {
          setPreferenceButtonLoading(true)
          
          const newPreferenceId = uuidv4();
          const information = { "closePortalOwner" : props?.closePortalowner?.value , "path" : `${ln.pathname}${location.search}`, "viewAs" : ownedBy?.hasOwnProperty('value') ? ownedBy?.value : null }
          const label = `Apps Library Filter Config for CP Page ${props?.closePortalowner?.label}`
          if(currentAppsLibraryPreferences?.length <= 0) {
            createPreference(
            newPreferenceId,
            'APPS_LIBRARY_FILTER_CONFIG',
            label,
            props?.closePortalowner?.value,                 
            'CLOSE_PORTAL',           
            userId,
            information,
            null,              
            (response) => {
                const newPreference = {
                    preferenceId: newPreferenceId,
                    label: label,
                    associationId: props?.closePortalowner?.value,
                    associationIdType: 'CLOSE_PORTAL',
                    preferenceType: 'APPS_LIBRARY_FILTER_CONFIG',
                    createdBy: userId,
                    lastUpdatedBy: userId,
                    lastUpdatedTimestamp: Date.now().toString(),
                    information: information
                };
                setCurrentAppsLibraryPreferences([newPreference]);
                setPreferenceButtonLoading(false)
            },
            (error) => {
                console.error('Error creating preferences:', error);
                const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save preferences";
                setPreferenceButtonLoading(false)
            }
        );
          } else {
            const currentPreferenceId = currentAppsLibraryPreferences[0]?.preferenceId
            updatePreference(
              currentPreferenceId,
              label,         
              userId,
              information,
              (response) => {
                  const newPreference = {
                      preferenceId: currentPreferenceId,
                      label: label,
                      associationId: props?.closePortalowner?.value,
                      associationIdType: 'CLOSE_PORTAL',
                      preferenceType: 'APPS_LIBRARY_FILTER_CONFIG',
                      createdBy: userId,
                      lastUpdatedBy: userId,
                      lastUpdatedTimestamp: Date.now().toString(),
                      information: information
                  };
                  setCurrentAppsLibraryPreferences([newPreference]);
                  setPreferenceButtonLoading(false)
              },
              (error) => {
                  console.error('Error updating preferences:', error);
                  const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save preferences";
                  setPreferenceButtonLoading(false)
              }
          )
          }
          
        }
      }

      const onResetAppFiltersClick = async () => {

        if(currentAppsLibraryPreferences?.length >= 0) {
          setPreferenceButtonLoading(true)
          const pref = currentAppsLibraryPreferences[0]
          deletePreference(pref?.preferenceId, null, () => {
            setCurrentAppsLibraryPreferences([])
            setPreferenceButtonLoading(false)
        }, (deleteError) => {
          setPreferenceButtonLoading(false)
            console.error("Error occured during deletion: ", deleteError)
        })
      }
        } 
        
    
      const getFilters = async () => {
        let qry = []
        let filtersApplied = []
        if (searchParams.get('searchQuery')) {
          qry.push(`searchString: "${searchParams.get('searchQuery')}"`)
        }
    
        if (searchParams.getAll('types')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.USE_CASE}",values:${JSON.stringify(searchParams.getAll('types'))}}`)
        }
        if (searchParams.getAll('outputs')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.OUTPUT}",values:${JSON.stringify(searchParams.getAll('outputs'))}}`)
        }
        if (searchParams.getAll('appTypes')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.TEMPLATE_ID}",values:${JSON.stringify(searchParams.getAll('appTypes').map((appType) => TEMPLATES[appType]))}}`)
        }
        if (searchParams.getAll('vps')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.VP}",values:${JSON.stringify(searchParams.getAll('vps'))}}`)
        }
        if (searchParams.getAll('tools')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.AUTOMATION_TOOLS}",values:${JSON.stringify(searchParams.getAll('tools'))}}`)
        }
    
        if (searchParams.getAll('status')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.STATUS}",values:${JSON.stringify(searchParams.getAll('status').map((status)=> APP_STATUSES[currentStage?.toUpperCase()][status]))}}`)
        }
    
        if (searchParams.getAll('processOwners')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.PROCESS_OWNER}", values:${JSON.stringify(searchParams.getAll('processOwners'))}}`)
        }
        if (searchParams.getAll('relevance')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.FINANCIAL_RELEVANCE}", values:${JSON.stringify(searchParams.getAll('relevance'))}}`)
        }
        if (searchParams.getAll('regions')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.REGION}", values:${JSON.stringify(searchParams.getAll('regions'))}}`)
        }
        if (searchParams.getAll('accountingTeams')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.ACCOUNTING_TEAM}", values:${JSON.stringify(searchParams.getAll('accountingTeams'))}}`)
        }
        if (searchParams.getAll('developerTeams')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.DEVELOPER_TEAM}", values:${JSON.stringify(searchParams.getAll('developerTeams'))}}`)
        }
        if (searchParams.getAll('cadence')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.CADENCE}", values:${JSON.stringify(searchParams.getAll('cadence'))}}`)
        }
        if (searchParams.getAll('launchDate')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.LAUNCH_QQ_YY}", values:${JSON.stringify(searchParams.getAll('launchDate'))}}`)
        }
        if (searchParams.getAll('inputSourceTypes')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.INPUT_SOURCE_TYPE}", values:${JSON.stringify(searchParams.getAll('inputSourceTypes'))}}`)
        }
        if (searchParams.getAll('ledgerImpacts')?.length > 0) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.LEDGER_INFO}", values:${JSON.stringify(searchParams.getAll('ledgerImpacts'))}}`)
        }
    
    
        if(ownedBy && ownedBy?.value) {
          filtersApplied.push(`{type:"owned_by", values:${JSON.stringify([ownedBy.value])}}`)
        }
    
        if (searchParams.getAll('orgs')?.length > 0 && !ln.pathname.startsWith('/AppsLibrary/Org')) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.ORGANIZATION}",values:${JSON.stringify(searchParams.getAll('orgs'))}}`)
        } else if ((ln.pathname.startsWith('/AppsLibrary/Org') || ln.pathname.startsWith('/appslibrary/org')) && org) {
          filtersApplied.push(`{type:"${TEMPLATE_APP.ORGANIZATION}",values:${JSON.stringify([org])}}`)
        }
    
    
        if (filtersApplied?.length > 0) {
          let tempFilterQry = ''
          tempFilterQry = tempFilterQry + '['
          tempFilterQry = tempFilterQry + filtersApplied.join(',')
          tempFilterQry = tempFilterQry + ']'
          qry.push(`filters:${tempFilterQry}`)
        }
        if (qry.length > 0) {
          return `(${qry.join(",")})`
        } else {
          return ''
        }
    
      }

      const includesIgnoreCase = (str, search) =>
        str?.toLowerCase().includes(search?.toLowerCase());

      const hasOverlap = (itemValues, filterValues) =>
        itemValues?.some(v => filterValues.includes(v));

      const hasMatch = (itemValues, filterValues) =>
        itemValues?.some(v => filterValues.some(f => f === v));

      const applyClientSideFilter = async (allApps) => {
        let filtered_apps = [...allApps];

        const query = searchParams.get('searchQuery');
        if (query) {
          filtered_apps = filtered_apps.filter(a =>
            includesIgnoreCase(a?.app_name, query) ||
            includesIgnoreCase(a?.app_description, query)
          );
        }

        // Client-side filtering
        const filters = {
          types: app => hasOverlap(app?.use_case, searchParams.getAll('types')),
          outputs: app => app?.output?.some(meta =>
            searchParams.getAll('outputs').some(search =>
              includesIgnoreCase(meta?.type, search)
            )
          ),
          vps: app => hasOverlap(app?.vp, searchParams.getAll('vps')),
          tools: app => hasOverlap(app?.automation_tools, searchParams.getAll('tools')),
          status: app => searchParams.getAll('status').includes(app?.status),
          appTypes: app => (searchParams.getAll('appTypes').map((appType) => TEMPLATES[appType])).includes(app?.template_id),
          processOwners: app => hasOverlap(app?.process_owner, searchParams.getAll('processOwners')),
          relevance: app => hasOverlap(app?.financial_relevance, searchParams.getAll('relevance')),
          regions: app => hasOverlap(app?.region, searchParams.getAll('regions')),
          cadence: app => hasOverlap(app?.cadence, searchParams.getAll('cadence')),
          accountingTeams: app => app?.accounting_team?.some(team =>
            searchParams.getAll('accountingTeams').includes(team?.team)
          ),
          developerTeams: app => searchParams.getAll('developerTeams')
            .includes(app?.developer_team?.team),
          launchDate: app => searchParams.getAll('launchDate')
            .includes(app?.launch_qq_yy),
          inputSourceTypes: app => hasMatch(app?.input_source_type, searchParams.getAll('inputSourceTypes')),
          ledgerImpacts: app => hasMatch(app?.ledger_info, searchParams.getAll('ledgerImpacts')),
          ownedBy: async app => {
            if (!ownedBy?.value) return true;
            const grcOwners = app?.grc_control_owner || [];
            if (grcOwners.some(owner => owner === ownedBy.value)) return true;
            for (const owner of grcOwners) {
              if(owner == null || owner.trim() === ''){
                continue
              }
              const supervisorChain = await getSupervisorChain(owner);
              if (supervisorChain?.toLowerCase().includes(ownedBy.value.toLowerCase())) {
                return true;
              }
            }
            return false;
          },
          orgs: app => {
            const isOrgPath = ln.pathname.toLowerCase().startsWith('/appslibrary/org');
            const filteredOrgs = isOrgPath ? [org] : searchParams.getAll('orgs');
            return app?.organization?.some(org => filteredOrgs.includes(org));
          },
        };

        for (const [key, predicate] of Object.entries(filters)) {
          const values = searchParams.getAll(key);
          if (values?.length > 0 || (key === 'orgs' && ln.pathname.toLowerCase().startsWith('/appslibrary/org') && org) || (key === 'ownedBy' && ownedBy?.value)) {
            if (key === 'ownedBy') {
              const results = await Promise.all(filtered_apps.map(predicate));
              filtered_apps = filtered_apps.filter((_, index) => results[index]);
            } else {
              filtered_apps = filtered_apps.filter(predicate);
            }
          }
        }

        return filtered_apps;
      };

      const loadProducts = async () => {
        setLoader(true)
        await getAllFavorites()
        await loadSearchDropDownValues();
      };



      const queryApps = async (resetCache = false) => {
        if (qryRef.current) return;
        qryRef.current = true;
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
          setLoader(true);
          setIsProcessing(true);

          let qResultJSON;
          const maxRetries = 3;
          setAppsLoadError(null);
          for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
              qResultJSON = await fetchApps('', resetCache);
              break;
            } catch (error) {
              console.error(`GraphQL fetch error (attempt ${attempt}/${maxRetries}):`, error);
              if (attempt === maxRetries) {
                setAppsLoadError('Failed to load apps. Please try refreshing the page.');
                return;
              }
              // Exponential backoff: 1s, 2s
              await new Promise(r => setTimeout(r, 1000 * attempt));
            }
          }

          const finalResult = await applyClientSideFilter(qResultJSON);

          generateFilterDropdown(qResultJSON, TEMPLATE_APP.VP);
          generateFilterDropdown(qResultJSON, TEMPLATE_APP.PROCESS_OWNER);
          generateAppTypesFilterDropdown(qResultJSON);

          setProducts(finalResult);
          setFilteredProducts(finalResult);
          setCurrentPageIndex(1);
        } finally {
          qryRef.current = false;
          setLoader(false);
          setIsProcessing(false);
          setIsProducsLoading(false);
          if(!pageLoadTime.isStopped) {
            stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.APPS_LIBRARY)
          }
        }
      };
    
      const loadSearchDropDownValues = async () => {
        let res = await getEditableFields()
        setFieldMetadata(res)
      }
      const favorite = async (appId) => {
        await isFavorite(appId)
        setFavDisabled(true)
        if (favoritesMap && favoritesMap[appId]) {
          await delFavorite(appId, userId, function onSuccess(result) {
            delete favoritesMap[appId]
          }, function onFailure(result) { })
        } else {
          await addFavorite(appId, userId, "default", function onSuccess(result) {
            favoritesMap[appId] = true
          }, function onFailure(result) { })
        }
        setFavDisabled(false)
      }

      const handleRatingChange = async (appId, rating) => {
        // Optimistic update
        setRatingsMap(prev => ({ ...prev, [appId]: rating }));

        if (rating === 0) {
          deleteRating(appId, "APP",
            () => {},
            (error) => {
              setRatingsMap(prev => { const copy = { ...prev }; delete copy[appId]; return copy; })
            }
          )
        } else {
          submitRating(appId, "APP", rating,
            () => {},
            (error) => {
              setRatingsMap(prev => { const copy = { ...prev }; delete copy[appId]; return copy; })
            }
          )
        }
      }

      useEffect(() => {
        if (userId) {
          getUserRatings("APP",
            (result) => {
              const ratings = result.data.getUserRatings || [];
              const map = {};
              ratings.forEach(({ entity_id, rating }) => {
                map[entity_id] = rating;
              });
              setRatingsMap(map);
            },
            (error) => {
            }
          )
        }
      }, [userId]);

      const formatViewCount = (count) => {
        if (count >= 1000000) {
          return `${(count / 1000000).toFixed(1)}M`;
        }
        if (count >= 1000) {
          return `${(count / 1000).toFixed(1)}k`;
        }
        return `${count}`;
      }
    
      const getCommaSeperatedOutputs = (item) => {
        let types = []
        item.output.forEach((output) => {
          types.push(output.type)
        })
        return types.join(', ')
      }
    
      const getUrl = (item) => {
        if (item.url) {
          return item.url
        } else {
          return `App/${item.app_id}`
        }
      }
    
       const getSupervisorChain = async (login) => {
         if (supervisorChainCache[login]) return supervisorChainCache[login];
         try {
           const details = await API.graphql(graphqlOperation(`
             query MyQuery {
               getEmployeeDetailsByLogin(login: "${login}")
             }
           `));
           const data = JSON.parse(details.data.getEmployeeDetailsByLogin);
           const supervisorChainLogins = data?.supervisorChain?.map((s) => s?.login) || [];
           const chain = supervisorChainLogins.join(',');
           setSupervisorChainCache(prev => ({...prev, [login]: chain}));
           return chain;
         } catch (error) {
           console.error('Error fetching supervisor chain:', error);
           return '';
         }
       };

       const cardsHeader = (
        <Header
          actions={
            (!(abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled) ? 
                <ButtonDropdown
                items={[
                  { text: "ABC App", id: "ABC_APP", "href": "/App", disabled: abcAddAppAccessDisabled },
                  { text: "QSC App", id: "QSC_APP", "href": "/QSCApp", disabled: qscAddAppAccessDisabled },
                  { text: "RAC App", id: "RAC_APP", "href": "/RACApp", disabled: racAddAppAccessDisabled },
                ]}
                variant="primary"
              disabled={abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled}
              >
                Add to Repository
              </ButtonDropdown> : <></>
              )
          }
        >
          {/* <SpaceBetween direction="horizontal" alignItems="center"> <span style={{color: "#656871"}}>Add an app to your favorites by clicking</span><img className="favorite_star" src={favLogo}></img></SpaceBetween> */}
        </Header>
       )

       const onFavoriteChange = () => {
        //loadProducts()
        getAllFavorites()
      }

    
      const topView = (
        
          // <div className="space-between-horizontal-flex">
          <Grid
            gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}
          >
                  <Box>
                    {!orgTogglechecked && (
                      <>
                      View as:
    
                      <Select
                            selectedOption={ownedBy? {label:`${ownedBy.label}`, value:`${ownedBy.value}`} : {label:`Default`, value:``}}
                            onChange={({ detail }) =>
                            setOwnedBy(detail.selectedOption)
                            }
                            placeholder="Select Alias"
                            options={suggestedLogins}
                            statusType={aliasesLoading ? "loading" : "finished"}
                            filteringType="manual"
                            loadingText="Loading aliases"
                            empty="No valid alias to recommend for entered text"
                            onLoadItems ={({detail})=>{
                              getSuggestedLoginsCaller(detail?.filteringText,10,true)
                            }}
                        />
                      <small>
                        <span style={{color: "#656871"}}>{`Apps owned by ${ownedBy?.value || 'the selected user'} or by people who report directly or indirectly to ${ownedBy?.value || 'them'}`}</span>
                      </small>
                    </>
                    )}
                 
    
                  </Box>
                  <Box float="right">
                  <ButtonDropdown
                items={[
                      {
                        text: "Organizations",
                        id: "orgs",
                        itemType: "checkbox",
                        checked: addFiltersBools.orgs,
                        disabled: true,
                        disabledReason: "Default filters can't be altered"
            
                      },
                      {
                        text: "Use Case Types",
                        id: "types",
                        itemType: "checkbox",
                        checked: addFiltersBools.types,
                        disabled: true,
                        disabledReason: "Default filters can't be altered"
                      },
                      {
                        text: "App status",
                        id: "statuses",
                        itemType: "checkbox",
                        checked: addFiltersBools.statuses,
                        disabled: true,
                        disabledReason: "Default filters can't be altered"
                      },
                      {
                        text: "Automation tools",
                        id: "tools",
                        itemType: "checkbox",
                        checked: addFiltersBools.tools,
                        disabled: true,
                        disabledReason: "Default filters can't be altered"
                      },
                      {
                        text: "Accounting VPs",
                        id: "vps",
                        itemType: "checkbox",
                        checked: addFiltersBools.vps,
                        disabled: false
                      },
                      {
                        text: "Process Owners",
                        id: "processOwners",
                        itemType: "checkbox",
                        checked: addFiltersBools.processOwners,
                        disabled: false
                      },
                      {
                        text: "App Type",
                        id: "appTypes",
                        itemType: "checkbox",
                        checked: addFiltersBools.appTypes,
                        disabled: false
                      },
                      {
                        text: "Financial relevance",
                        id: "relevance",
                        itemType: "checkbox",
                        checked: addFiltersBools.relevance,
                        disabled: false
                      },
    
                      {
                        text: "Region",
                        id: "regions",
                        itemType: "checkbox",
                        checked: addFiltersBools.regions,
                        disabled: false
                      },
    
                      {
                        text: "Accounting team",
                        id: "accountingTeams",
                        itemType: "checkbox",
                        checked: addFiltersBools.accountingTeams,
                        disabled: false
                      },
                      {
                        text: "Developer team",
                        id: "developerTeams",
                        itemType: "checkbox",
                        checked: addFiltersBools.developerTeams,
                        disabled: false
                      },
                      {
                        text: "Run Frequency",
                        id: "cadence",
                        itemType: "checkbox",
                        checked: addFiltersBools.cadence,
                        disabled: false
                      },
                      {
                        text: "Launch date",
                        id: "launchDate",
                        itemType: "checkbox",
                        checked: addFiltersBools.launchDate,
                        disabled: false
                      },
                      {
                        text: "Input source type",
                        id: "inputSourceTypes",
                        itemType: "checkbox",
                        checked: addFiltersBools.inputSourceTypes,
                        disabled: false
                      },
                      {
                        text: "Process outputs",
                        id: "outputs",
                        itemType: "checkbox",
                        checked: addFiltersBools.outputs,
                        disabled: false
                      },
                      {
                        text: "Ledger impact",
                        id: "ledgerImpacts",
                        itemType: "checkbox",
                        checked: addFiltersBools.ledgerImpacts,
                        disabled: false
                      },
    
                      
                ]}
    
                onItemClick={(event) => {
                  
                  setAddFiltersBools({ ...addFiltersBools, [event.detail.id]: !addFiltersBools[event.detail.id] })
                  if(!addFiltersBools[event.detail.id] === false) {
                    searchParams.delete(`${event.detail.id}`)
                    history.replace({
                      ...history.location.search,
                      search: `${searchParams.toString()}`,
                    })
                  }
                }}
              >
                Add / Remove Filters
              </ButtonDropdown>
              </Box>
              </Grid>
        //     {/* <Box>
        //     <SpaceBetween direction="horizontal" size="l">
        //       <Box>
                
        //       </Box>
        //       <Box>
        //         <Toggle
        //   onChange={({ detail }) =>
        //     setOrgToggleChecked(detail.checked)
        //   }
        //   checked={orgTogglechecked}
        // >
          
        //   <Box>
        //   <small>View by organization</small>
        //   </Box>
        //   </Toggle>
        //   <Select
        //   selectedOption={org? {label:`${org}`, value:`${org}`} : {label:`All`, value:``} }
        //   onChange={({ detail }) =>
        //     history.push(`/AppsLibrary/Org/${detail.selectedOption.value}`)
        //   }
        //   options={organizations}
        //   disabled={!orgTogglechecked}
        // />
    
        //   </Box>
        //   </SpaceBetween>
        //   </Box> */}
        //   </div>
        
      )
    

    const Apps = (
        <>
        {
            (appsActiveTabId !== 'insights' && appsActiveTabId !== 'approvals') && (
              <Box>
                <div class='views'>
                  <SpaceBetween size="m" direction="horizontal">
                    {/* <img className={view == 'Grid' ? 'button_selected' : 'button_unselected'} src={grid} onClick={() => setView('Grid')}></img>
                  <img className={view == 'List' ? 'button_selected' : 'button_unselected'} src={list} onClick={() => setView('List')}></img> */}


                    {/* <SegmentedControl
                      selectedId={view}
                      onChange={({ detail }) =>
                        setView(detail.selectedId)
                      }
                      label="View segmented control"
                      options={[
                        { text: "Card view", id: "Grid" },
                        { text: "List view", id: "List" },
                      ]}
                    /> */}
                  </SpaceBetween>
                </div>
              </Box>
            )
          }
        <Tabs
                tabs={[
                  
                  {
                    label: org ? `${org} Applications` : `All Applications`,
                    id: "apps",
                    content: (
                      <>
              <Autosuggest
                onChange={({ detail }) => {
                  searchParams.delete(`searchQuery`)
                  if (detail.value) {
                    searchParams.append(`searchQuery`, detail.value)
                  }
                  history.replace({
                    ...history.location.search,
                    search: `${searchParams.toString()}`,
                  })
    
                }
                }
                value={searchParams.get('searchQuery') ? searchParams.get('searchQuery') : ''}
                placeholder={`Search ${org ? org : `all`} applications`}
                enteredTextLabel={(value) => `Searching: ${value}`}
                options={searchSuggestions}
                virtualScroll
              />
              <br />
              <Box>
                <ExpandableSection
                  variant="default"
                  headerText="Filter by"
                >
                  
                <Container>
                  
                
                  {topView}
                  <Box>
                  <ColumnLayout columns={4}>
                    {ln.pathname?.startsWith('/AppsLibrary/Org') && org ? (
                      <></>
                    ) : (
                      <Box>
                        <Box variant="awsui-key-label">Organizations</Box>
                        <Multiselect
                          selectedOptions={searchParams.getAll('orgs').map((org) => (
                            {
                              label: org,
                              value: org
                            }
                          ))}
                          onChange={({ detail }) => {
                            // console.log(history.location.search)
                            searchParams.delete(`orgs`)
                            detail.selectedOptions?.forEach((org) => searchParams.append(`orgs`, org.value))
    
                            history.replace({
                              ...history.location.search,
                              search: `${searchParams.toString()}`,
                            })
    
                          }
                          }
                          options={organizations}
                          placeholder="Filter on Organizations"
                        />
                      </Box>)}
    
                    <Box>
                      <Box variant="awsui-key-label">Use Case Types</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('types').map((type) => (
                          {
                            label: type,
                            value: type
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`types`)
                          detail.selectedOptions?.forEach((type) => searchParams.append(`types`, type.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={useCaseTypes}
                        placeholder="Filter on Use Case Types"
                      />
                    </Box>
    
                    <Box>
                      <Box variant="awsui-key-label">App status</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('status').map((status) => (
                          {
                            label: status,
                            value: status
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`status`)
                          detail.selectedOptions?.forEach((status) => searchParams.append(`status`, status.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={statuses}
                        placeholder="Filter on app status"
                      />
                    </Box>
    
                    <Box>
                      <Box variant="awsui-key-label">Automation tools</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('tools').map((tool) => (
                          {
                            label: tool,
                            value: tool
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`tools`)
                          detail.selectedOptions?.forEach((tool) => searchParams.append(`tools`, tool.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={allAutomationTools}
                        placeholder="Filter on automation tools"
                      />
                    </Box>
    
                    {addFiltersBools.vps && (
                      <Box>
                      <Box variant="awsui-key-label">Accounting VPs</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('vps').map((vp) => (
                          {
                            label: vp,
                            value: vp
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`vps`)
                          detail.selectedOptions?.forEach((vp) => searchParams.append(`vps`, vp.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={allAccountingVps}
                        placeholder="Filter on Accounting VPs"
                      />
                    </Box>
                    )}
                    
                    {addFiltersBools.processOwners && (
                    <Box>
                      <Box variant="awsui-key-label">Process owners</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('processOwners').map((processOwner) => (
                          {
                            label: processOwner,
                            value: processOwner
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`processOwners`)
                          detail.selectedOptions?.forEach((processOwner) => searchParams.append(`processOwners`, processOwner.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={processOwners}
                        placeholder="Filter on process owners"
                      />
                    </Box>
                    )}
                    
    
                  {addFiltersBools.appTypes && (
                    <Box>
                      <Box variant="awsui-key-label">App Type</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('appTypes').map((appType) => (
                          {
                            label: `${appType}`,
                            value: TEMPLATES[appType]
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`appTypes`)
                          detail.selectedOptions?.forEach((appType) => searchParams.append(`appTypes`, appType.label))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={appTypes}
                        placeholder="Filter on App type"
                      />
                    </Box>)
                    }
    
                    {addFiltersBools.relevance &&(
                      <Box>
                      <Box variant="awsui-key-label">Financial relevance</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('relevance').map((relevance) => (
                          {
                            label: relevance,
                            value: relevance
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`relevance`)
                          detail.selectedOptions?.forEach((relevance) => searchParams.append(`relevance`, relevance.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={financialRelevanceValues}
                        placeholder="Filter on financial relevance"
                      />
                    </Box>
                    )}
    
                    {addFiltersBools.regions && (
                      <Box>
                      <Box variant="awsui-key-label">Regions</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('regions').map((region) => (
                          {
                            label: region,
                            value: region
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`regions`)
                          detail.selectedOptions?.forEach((region) => searchParams.append(`regions`, region.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={regions}
                        placeholder="Filter on regions"
                      />
                    </Box>
                    )}
    
                    {addFiltersBools.accountingTeams && (
                    <Box>
                      <Box variant="awsui-key-label">Accounting teams</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('accountingTeams').map((accountingTeam) => (
                          {
                            label: accountingTeam,
                            value: accountingTeam
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`accountingTeams`)
                          detail.selectedOptions?.forEach((accountingTeam) => searchParams.append(`accountingTeams`, accountingTeam.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={accountingTeams}
                        placeholder="Filter on accounting teams"
                      />
                    </Box>
                    )}
                    {addFiltersBools.developerTeams && (
                      <Box>
                      <Box variant="awsui-key-label">Developer teams</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('developerTeams').map((developerTeam) => (
                          {
                            label: developerTeam,
                            value: developerTeam
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`developerTeams`)
                          detail.selectedOptions?.forEach((developerTeam) => searchParams.append(`developerTeams`, developerTeam.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={developerTeams}
                        placeholder="Filter on developer teams"
                      />
                    </Box>
                    )}
                    {addFiltersBools.cadence && (
                      <Box>
                      <Box variant="awsui-key-label">Run frequency</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('cadence').map((cadence) => (
                          {
                            label: cadence,
                            value: cadence
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`cadence`)
                          detail.selectedOptions?.forEach((cadence) => searchParams.append(`cadence`, cadence.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={cadences}
                        placeholder="Filter on run frequency"
                      />
                    </Box>
                    )}
                    {addFiltersBools.launchDate && (
                      <Box>
                      <Box variant="awsui-key-label">Launch date</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('launchDate').map((launchDate) => (
                          {
                            label: launchDate,
                            value: launchDate
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`launchDate`)
                          detail.selectedOptions?.forEach((launchDate) => searchParams.append(`launchDate`, launchDate.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={launchDates}
                        placeholder="Filter on launch date"
                      />
                    </Box>
                    )}
                    {addFiltersBools.inputSourceTypes && (
                      <Box>
                      <Box variant="awsui-key-label">Input source types</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('inputSourceTypes').map((inputSourceType) => (
                          {
                            label: inputSourceType,
                            value: inputSourceType
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`inputSourceTypes`)
                          detail.selectedOptions?.forEach((inputSourceType) => searchParams.append(`inputSourceTypes`, inputSourceType.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={inputDataSources}
                        placeholder="Filter on input source types"
                      />
                    </Box>
                    )}
                    {addFiltersBools.outputs && (
                    <Box>
                      <Box variant="awsui-key-label">Process output</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('outputs').map((output) => (
                          {
                            label: output,
                            value: output
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`outputs`)
                          detail.selectedOptions?.forEach((output) => searchParams.append(`outputs`, output.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={processOutputs}
                        placeholder="Filter on process outputs"
                      />
                    </Box>)
                    }
                    {addFiltersBools.ledgerImpacts && (
                      <Box>
                      <Box variant="awsui-key-label">Ledger impact</Box>
                      <Multiselect
                        selectedOptions={searchParams.getAll('ledgerImpacts').map((ledgerImpact) => (
                          {
                            label: ledgerImpact,
                            value: ledgerImpact
                          }
                        ))}
                        onChange={({ detail }) => {
                          // console.log(history.location.search)
                          searchParams.delete(`ledgerImpacts`)
                          detail.selectedOptions?.forEach((ledgerImpact) => searchParams.append(`ledgerImpacts`, ledgerImpact.value))
    
                          history.replace({
                            ...history.location.search,
                            search: `${searchParams.toString()}`,
                          })
    
                        }
                        }
                        options={ledgerImpacts}
                        placeholder="Filter on ledger impacts"
                      />
                    </Box>
                    )}
                  </ColumnLayout>
                  <br></br>
                  </Box>
          <Grid
            gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}
          >
            {props?.addOrEditAccess && (
              <>
            <Box>
              <small>
                <span style={{color: "#656871"}}>{`Save current filters as team preferences or reset to default view`}</span>
              </small>
            </Box>

            <Box float="right">
                
                  <>
                  <ButtonDropdown
                loading={preferenceButtonLoading}
                  items={[
                      {
                          text: "Save View For Team",
                          id: "save",
                          iconName: "folder",
                      },
                      {
                          text: "Reset View",
                          id: "reset",
                          iconName: "refresh",
                          disabled: currentAppsLibraryPreferences?.length <= 0,
                          disabledReason: "No preferences sets"
                      }
                  ]}
                  onItemClick={(event) => {
                      if (event.detail.id == 'save') {
                          onSaveAppFiltersClick()
                      } else if (event.detail.id == 'reset') {
                          onResetAppFiltersClick()
                      }
                      
                  }}
              >
                  Library Preferences
              </ButtonDropdown>
              </>
                
                <br></br>
                <br></br>
              </Box>
              </>
              ) } 
            </Grid>
              </Container>
            </ExpandableSection>
              </Box>
              <br></br>
              {loader ? (<Box>
          <Spinner></Spinner>
          Loading...
        </Box>) : (
          <>
          {appsLoadError && (
            <Flashbar items={[{
              type: 'error',
              content: appsLoadError,
              action: <Button onClick={() => queryApps(true)}>Retry</Button>,
              dismissible: true,
              onDismiss: () => setAppsLoadError(null),
              id: 'apps-load-error'
            }]} />
          )}
          {view == 'Grid' ? <Cards
                className="apps-cards-container"
                cardDefinition={{
                  header: item => (
                    <div className="header_menu">
                      <div className="link">
                        <Link to={getUrl(item)}> {item.app_name}</Link>
                      </div>
                      <div className={favDisabled ? "icon_disabled" : "icon_apps"} disabled={favDisabled} >
                        {favoritesMap[item.app_id] && (<span style={{ cursor: "pointer", color:"#ff9900"}} onClick={() => favorite(item.app_id)}><Icon size= "medium" name="heart-filled"/></span>)}
                        {!favoritesMap[item.app_id] && (<span style={{ cursor: "pointer", color:"#ff9900" }} onClick={() => favorite(item.app_id)}><Icon name="heart" size= "medium"/></span>)}
                      </div>
                      <div className="card-rating-bottom" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
                        <br></br>
                        <br></br>
                        <StarRating
                          value={ratingsMap[item.app_id] || 0}
                          averageRating={item.rating_avg || ratingsMap[item.app_id] || 0}
                          ratingCount={item.rating_count || (ratingsMap[item.app_id] ? 1 : 0)}
                          onChange={(rating) => handleRatingChange(item.app_id, rating)}
                        />
                      </div>
                      <div className="card-views-bottom">
                        <span style={{ fontSize: "13px", display: "inline-flex", alignItems: "center", gap: "4px" }}>
                          <span>👁️</span>
                          <span style={{ color: "#5f6b7a" }}>{item.view_count != null ? formatViewCount(item.view_count) : "0"}</span>
                        </span>
                      </div>
                    </div>
                  ),
                  sections: [
                    {
                      id: "card_body",
                      header: "",
                      content: (item) => {
                        const description = item?.app_description?.length < 200
                          ? item?.app_description
                          : `${item?.app_description?.slice(0, 200)}...`;

                        let list = [];
                        if (item.status) {
                          if (item.status === 'Deprecated') {
                            list.push(<span key="status" style={{color:"#db0000"}}><Icon name="status-negative" variant="error" />&nbsp;{item.status}</span>);
                          } else if (item.status === 'WIP') {
                            list.push(<span key="status" style={{color:"#0f141a"}}><Icon name="status-pending" variant="normal" />&nbsp;{item.status}</span>);
                          } else if (item.status === 'Active') {
                            list.push(<span key="status" style={{color:"#00802f"}}><Icon name="status-positive" variant="success" />&nbsp;{item.status}</span>);
                          }
                        } else {
                          list.push(<span key="status" style={{color:"#855900"}}><Icon name="status-warning" variant="warning" />&nbsp;No status</span>);
                        }
                        if (item.use_case) {
                          item.use_case.forEach((i, index) => list.push(<span key={`uc-${index}`} className={LABEL_COLOR_CLASSES[(index) % 3]}>{i}</span>));
                        }

                        return (
                          <div className="card-body-content">
                            <div>{description}</div>
                            <ul style={{ listStyleType: "none", paddingLeft: "0px", marginTop: "8px", flexWrap: "wrap" }}>
                              <SpaceBetween direction="horizontal" size="m">
                                {list.map((label, index) => (
                                  <li key={index}>{label}</li>
                                ))}
                              </SpaceBetween>
                            </ul>
                          </div>
                        );
                      },
                    },
                    {
                      id: "rating",
                      content: (item) => (
                        <div style={{ height: "48px" }}></div>
                      ),
                    }
                  ]
                }}
                // header={cardsHeader}
                stickyHeader
                cardsPerRow={[{ minWidth: 900, cards: 3 }]}
                items={pageItems}
                loading={isProducsLoading}
                loadingText="Loading resources"
                empty={
                  <Box textAlign="center" color="inherit">
                    <b>No applications</b>
                    <Box
                      padding={{ bottom: "s" }}
                      variant="p"
                      color="inherit"
                    >
                      No applications to display.
                    </Box>
                  </Box>
                }
    
                preferences = {
                  <>
                  {(!(abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled) ? 
                <ButtonDropdown
                items={[
                  { text: "ABC App", id: "ABC_APP", "href": "/App", disabled: abcAddAppAccessDisabled },
                  { text: "QSC App", id: "QSC_APP", "href": "/QSCApp", disabled: qscAddAppAccessDisabled },
                  { text: "RAC App", id: "RAC_APP", "href": "/RACApp", disabled: racAddAppAccessDisabled },
                ]}
                variant="primary"
              disabled={abcAddAppAccessDisabled && qscAddAppAccessDisabled && racAddAppAccessDisabled}
              >
                Add to Repository
              </ButtonDropdown> : <></>
              )}
                  </>
                }
                pagination={
                  
                  <Pagination currentPageIndex={currentPageIndex}
                    onChange={({ detail }) =>
                      setCurrentPageIndex(detail.currentPageIndex)
                    }
                    pagesCount={pagesCount} />        
                }
                filter = {
                  <TextContent> <h4><span style={{color: "#656871"}}>{pageItems
                    ? filteredProducts.length 
                    : ""}
                    </span> Results 
                    </h4>
                </TextContent>
                }
              /> :
                <Table
                  columnDefinitions={[
                    {
                      id: "fav",
                      cell: e => <div className={favDisabled ? "center_disabled" : "center"} disabled={favDisabled} >
                        {favoritesMap[e.app_id] && (<span style={{ cursor: "pointer", color:"#ff9900"}} onClick={() => favorite(e.app_id)}><Icon size= "medium" name="heart-filled"/></span>)}
                        {!favoritesMap[e.app_id] && (<span style={{ cursor: "pointer", color:"#ff9900"}} onClick={() => favorite(e.app_id)}><Icon size= "medium" name="heart"/></span>)}
                      </div>,
                      width: 50,
                      isRowHeader: true
                    },
                    {
                      id: "name",
                      header: "Name",
                      cell: e => <Link to={getUrl(e)}> {e.app_name}</Link>,
                      width: 300,
                    },
                    {
                      id: "app_description",
                      header: "Description",
                      cell: e => e.app_description,
                      width: 350,
                    },
                    {
                      id: "status",
                      header: "Status",
                      cell: e => (e.status ? (
                            e.status === 'Active' ?
                          <><span><Icon name="status-positive" variant="success" />&nbsp;<span style={{color: "#00802f"}}>{e.status}</span></span><br/></>
                          : e.status === 'Deprecated' ? 
                          <><span ><Icon name="status-negative" variant="error" />&nbsp;<span style={{color: "#db0000"}}>{e.status}</span></span><br/></>
                          : e.status === 'WIP' ?
                          <><span><Icon name="status-pending" variant="normal" />&nbsp;<span style={{color: "#0f141a"}}>{e.status}</span></span><br/></>
                          :<></>
                        ) :  <span><Icon name="status-warning" variant="warning" />&nbsp;<span style={{color: "#855900"}}>No status</span></span>),
                        // (e.status ? e.status : "No status"),
                      
                      width: 200,
                    },
                    {
                      id: "organization",
                      header: "Organization",
                      cell: e => (e.organization ? e.organization.join(', ') : "Not Available"),
                      width: 200,
                    },
                    {
                      id: "useCaseType",
                      header: "Use Case Type",
                      cell: e => (e.use_case ? e.use_case.join(', ') : "Not Available"),
                      width: 200,
                    },
                    {
                      id: "processOutput",
                      header: "Process output",
                      cell: e => (e.output ? getCommaSeperatedOutputs(e) : "Not Available"),
                      width: 200,
                    },
                    {
                      id: "vp",
                      header: "VP",
                      cell: e => (e.vp ? e.vp.join(', ') : "Not Available"),
                      width: 200,
                    }
                  ]}
                  items={pageItems}
                  loadingText="Loading resources"
                  resizableColumns
                  empty={
                    <Box textAlign="center" color="inherit">
                      <b>No applications</b>
                      <Box
                        padding={{ bottom: "s" }}
                        variant="p"
                        color="inherit"
                      >
                        No applications to display.
                      </Box>
                    </Box>
                  }
                  header={cardsHeader}
                  pagination={
                    <Pagination currentPageIndex={currentPageIndex}
                      onChange={({ detail }) =>
                        setCurrentPageIndex(detail.currentPageIndex)
                      }
                      pagesCount={pagesCount} />
                  }
                  filter={
                    <TextContent> <h4>Results <span style={{color: "#656871"}}>{pageItems
                      ? "(" + filteredProducts.length + ")"
                      : ""}
                      </span>
                      </h4>
                  </TextContent>
                  }
                />
              }
    
          </>
        )    
        }
        </>
                    )
                  },
                  {
                    label: "My Favorites",
                    id: "favorites",
                    content: (<>
                      {loader ? (<Box>
                        <Spinner></Spinner>
                        Loading...
                      </Box>) : (<Box>
                        <Favorite userId={userId} allApps={filteredProducts} changeToggle={onFavoriteChange} view={view} />
                      </Box>)}
                    </>)
                  },
                  {
                    label: "Featured",
                    id: "featured",
                    content: (<>
                      {loader ? (<Box>
                        <Spinner></Spinner>
                        Loading...
                      </Box>) : (<Box>
                        <Featured userId={userId} allApps={filteredProducts} changeToggle={onFavoriteChange} view={view} />
                      </Box>)}
                    </>)
                  },
                  {
                    label: "My approvals",
                    id: "approvals",
                    content: <><ApprovalsHome/></>
                  },
                ]}
                activeTabId={appsActiveTabId}
                onChange={(event) => { setAppsActiveTabId(event.detail.activeTabId) }}
              />
        </>
      )
      
    return (
       <>
       {Apps}
       </>
    );
}

export default Apps;
